module.exports = __webpack_public_path__ + "static/media/bandy.5dc1b91d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/bandy.svg
// module id = 359
// module chunks = 7